import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { COMMODITIES, HEADER_IMG } from "../data/site";

export default function Commodities() {
  return (
    <div data-testid="commodities-page">
      <PageHeader
        overline="Engineering Commodities"
        title="45+ commodities we source."
        subtitle="From sheet metal and CNC machining to castings, forgings, moulding and electricals — we source engineered products across every major manufacturing process."
        bgImage={HEADER_IMG.commodities}
      />

      <section className="max-w-[1440px] mx-auto px-5 sm:px-8 py-20 md:py-28">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border">
          {COMMODITIES.map((c, i) => (
            <Reveal key={c.title} delay={(i % 3) * 0.05} className="bg-card group flex flex-col p-7 hover:bg-navy transition-colors">
              <div className="flex items-center justify-between mb-6">
                <span className="h-12 w-12 bg-brand-orange grid place-items-center">
                  <c.icon size={22} className="text-white" strokeWidth={1.6} />
                </span>
                <span className="font-mono text-border text-lg font-bold group-hover:text-white/30 transition-colors">{String(i + 1).padStart(2, "0")}</span>
              </div>
              <h3 className="font-display font-bold text-xl mb-2 group-hover:text-white transition-colors">{c.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed flex-1 group-hover:text-white/60 transition-colors">{c.desc}</p>
              <Link to="/quote" data-testid={`commodity-quote-${i}`}
                className="mt-5 inline-flex items-center gap-2 font-mono uppercase text-[10px] tracking-[0.2em] text-brand-orange hover:gap-3 transition-all">
                Request Quote <ArrowUpRight size={13} />
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-navy text-white py-20 md:py-28">
        <div className="max-w-[1440px] mx-auto px-5 sm:px-8 flex flex-col md:flex-row items-center justify-between gap-8">
          <h2 className="font-display font-black text-3xl md:text-5xl tracking-tight max-w-2xl">Don't see your part? We source custom engineered components too.</h2>
          <Link to="/quote" className="inline-flex items-center gap-2 bg-brand-orange px-8 py-4 font-mono uppercase text-[11px] tracking-[0.18em] hover:bg-brand-orangeHover transition-colors whitespace-nowrap">
            Request a Quote <ArrowUpRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
}
